import { render, staticRenderFns } from "./project-kind-setting.vue?vue&type=template&id=c162b864&scoped=true&"
import script from "./project-kind-setting.vue?vue&type=script&lang=js&"
export * from "./project-kind-setting.vue?vue&type=script&lang=js&"
import style0 from "./project-kind-setting.vue?vue&type=style&index=0&id=c162b864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c162b864",
  null
  
)

export default component.exports